import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { app } from "../Firebase";
import { getMessaging as getFirebaseMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";
//@ts-ignore
import { saveUserFirebaseToken, deleteUserFirebaseToken } from "@services/publicUserAPI";
//@ts-ignore
import { createNotification, requestPermissions } from "@utils/NotificationsUtils";
//@ts-ignore
import { isMobile } from "@utils/DeviceDetection";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import { getURLPage } from "@utils/URLPagesFactory";
var VAPID_KEY = "BGKnW8fEPN-OC_m8QKzZT7d4wU08RQR6TjwAbHhq_IoVQR08G6sTtPqfu9XRsG88lk0FNWJTufxIFNrFtw3bX8M";
var ACTIVATE_FIREBASE_NOTIFICATIONS = true;
var messaging = null;
try {
  messaging = getFirebaseMessaging(app);
} catch (e) {
  console.error("[firebaseMessaging.ts]", e);
}
var firebaseToken = "";
var messageListenerSet = false;
var firebaseMessagingSw = null;
//@ts-ignore
export var isFirebaseSwInitialized = () => !!firebaseMessagingSw;
var generateMessagingToken = () => __awaiter(void 0, void 0, void 0, function* () {
  //@ts-ignore
  if (!messaging || !firebaseMessagingSw) return "";
  return yield getToken(messaging, {
    vapidKey: VAPID_KEY,
    serviceWorkerRegistration: firebaseMessagingSw
  });
});
/**
 * Initializes the firebase service worker and generates a messaging token needed to enable the web push notifications
 * @return True if the registration has been successful, false otherwise
 * */
export var initFirebaseSw = () => __awaiter(void 0, void 0, void 0, function* () {
  if (!messaging || !ACTIVATE_FIREBASE_NOTIFICATIONS) return false;
  try {
    yield requestPermissions();
    if (!("serviceWorker" in navigator)) {
      console.error("Service workers are not supported.");
      return false;
    }
    // Register a service worker hosted at the root of the
    // site using the default scope.
    //@ts-ignore
    if (!firebaseMessagingSw) {
      firebaseMessagingSw = yield navigator.serviceWorker.register("/firebase-messaging-sw.js");
      //updating the service worker
      yield firebaseMessagingSw.update();
    }
    firebaseToken = yield generateMessagingToken();
    /* Redirecting to saveSearchPage when the user is logged */
    navigator.serviceWorker.onmessage = event => {
      var {
        data
      } = event;
      if (!data.backgroundMessage) return;
      sendGAEvent("push_notification_opened", {
        event_location: "Notifica Push - Android_or_Web"
      });
      /* Saving the analytics event */
      if (!data.pageToRedirect) return;
      window.location.href = getURLPage(data.pageToRedirect);
    };
    setOnMessageListener();
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
});
export var saveFirebaseToken = () => __awaiter(void 0, void 0, void 0, function* () {
  //@ts-ignore
  if (!messaging || !ACTIVATE_FIREBASE_NOTIFICATIONS || !firebaseMessagingSw) return;
  if (!firebaseToken) {
    firebaseToken = yield generateMessagingToken();
  }
  yield saveUserFirebaseToken(firebaseToken);
});
export var removeFirebaseToken = () => __awaiter(void 0, void 0, void 0, function* () {
  //@ts-ignore
  if (!messaging || !ACTIVATE_FIREBASE_NOTIFICATIONS || !firebaseMessagingSw) return false;
  if (!firebaseToken) return true;
  var res = yield deleteUserFirebaseToken(firebaseToken);
  firebaseToken = "";
  try {
    //@ts-ignore
    deleteToken(messaging);
  } catch (e) {
    console.log("deleteToken error", e);
  }
  return res;
});
var setOnMessageListener = () => {
  if (messageListenerSet || !messaging) return;
  //Setting a callback function when the user clicks the notification (foreground notifications)
  onMessage(messaging, payload => {
    var _a, _b, _c, _d, _e;
    // const saveSearchNotifications = payload.data as SaveSearchNotification;
    var title = ((_a = payload.notification) === null || _a === void 0 ? void 0 : _a.title) || "";
    var body = ((_b = payload.notification) === null || _b === void 0 ? void 0 : _b.body) || "";
    var icon = ((_c = payload.notification) === null || _c === void 0 ? void 0 : _c.icon) || "";
    var badge = ((_d = payload.data) === null || _d === void 0 ? void 0 : _d.badge) || "";
    var urlToRedirect = ((_e = payload.data) === null || _e === void 0 ? void 0 : _e.pageToRedirect) || "";
    //It's pointless to use the Notifications API since it can't show foreground messages!
    !isMobile() && createNotification(title, body, icon, badge, urlToRedirect);
    //Triggering the snackbar
    document.dispatchEvent(new CustomEvent("foreground.message.received", {
      detail: {
        title,
        body,
        urlToRedirect
      }
    }));
  });
  messageListenerSet = true;
};